import { FirestorePath, NameValuePair, Page } from "@zickko/shared";
import { OrderByDirection, WhereFilterOp } from "firebase/firestore";
import { Cursor, firestoreApi } from "../services/firestoreApi";

export class CollectionRepo<K extends NameValuePair<string>, T> {
  //
  protected firestorePath: FirestorePath<K, T>;

  constructor(firestorePath: FirestorePath<K, T>) {
    this.firestorePath = firestorePath;
  }

  ref = (key: K) => {
    return firestoreApi.collectionRef(this.firestorePath.path(key));
  };

  page = async (args: {
    key: K;
    where?: [Extract<keyof T, string>, WhereFilterOp, unknown][];
    orderByField: Extract<keyof T, string>;
    orderByDirection: OrderByDirection;
    limit?: number;
    cursor?: Cursor;
  }): Promise<Page<T>> => {
    return firestoreApi.page({ path: this.firestorePath.path(args.key), ...args });
  };

  query = async (args: {
    key: K;
    where?: [Extract<keyof T, string>, WhereFilterOp, unknown][];
    orderByField: Extract<keyof T, string>;
    orderByDirection: OrderByDirection;
    limit: number;
  }): Promise<T[] | undefined> => {
    return firestoreApi.query({ path: this.firestorePath.path(args.key), ...args });
  };

  getCount = async (args: { key: K }): Promise<number | undefined> => {
    const path = this.firestorePath.path(args.key);
    return firestoreApi.countAll({ path });
  };

  // /**
  //  * WARNING: Potentially dangerous method, may load huge list of documents.
  //  */
  // listAll_UNSAFE = async (key: K): Promise<T[]> => {
  //   const collection = await getDocs(this.ref(key));
  //   if (collection.empty) return [];
  //   return collection.docs.map((doc) => doc.data() as T);
  // };
}
